// API client tipado pra `/api/clients/:clientId/contacts`.
//
// Schema/validação reaproveitados de `@control-center/shared`. Tipo `ContactEntity`
// é a reconstrução do model `ClientContact` do backend (sem timestamps de auditoria
// expostos pra UI — só o necessário).

import type {
  ContactPreferredChannelSchema as ContactPreferredChannel,
  ContactRoleSchema as ContactRole,
  CreateClientContactDto,
  QueryClientContactsDto,
  UpdateClientContactDto,
} from '@control-center/shared';

import { apiClient } from './api-client';

export type { ContactRole, ContactPreferredChannel };

export interface ContactEntity {
  id: string;
  client_id: string;
  name: string;
  role: ContactRole;
  email: string | null;
  phone: string | null;
  whatsapp: string | null;
  notes: string | null;
  is_active: boolean;
  preferred_channel: ContactPreferredChannel;
  receives_billing_notifications: boolean;
  receives_fiscal_documents: boolean;
  created_at: string;
  updated_at: string;
  inactivated_at: string | null;
  inactivated_by_user_id: string | null;
  inactivated_reason: string | null;
}

interface ListResponse {
  items: ContactEntity[];
}

interface SingleResponse {
  data: ContactEntity;
}

export async function fetchContacts(
  clientId: string,
  params: QueryClientContactsDto = {},
): Promise<ContactEntity[]> {
  const { data } = await apiClient.get<ListResponse>(`/api/clients/${clientId}/contacts`, {
    params,
  });
  return data.items;
}

export async function fetchContact(clientId: string, contactId: string): Promise<ContactEntity> {
  const { data } = await apiClient.get<SingleResponse>(
    `/api/clients/${clientId}/contacts/${contactId}`,
  );
  return data.data;
}

export async function createContact(
  clientId: string,
  payload: CreateClientContactDto,
): Promise<ContactEntity> {
  const { data } = await apiClient.post<SingleResponse>(
    `/api/clients/${clientId}/contacts`,
    payload,
  );
  return data.data;
}

export async function updateContact(
  clientId: string,
  contactId: string,
  payload: UpdateClientContactDto,
): Promise<ContactEntity> {
  const { data } = await apiClient.patch<SingleResponse>(
    `/api/clients/${clientId}/contacts/${contactId}`,
    payload,
  );
  return data.data;
}
